import styled from 'styled-components'
import HeadingNumber from '../general/HeadingNumber'

const ThickHeading = styled.div`
	color: ${props => props.theme.text};
	font-weight: 700;
	text-align: left;

	align-items: center;
	display: flex;

	> svg {
		color: ${props => props.theme.textLight};
		margin-right: 0.5rem;
	}

	> ${HeadingNumber} {
		position: relative;
		top: 1px;
	}

	${props => props.sticky && `
		position: sticky;
		top: 0;
		z-index: ${props.theme.zLayer3};

		background: ${props.theme.background};
		padding: 0.5rem 1rem;
		margin: 0 -1rem;
		width: calc(100% + 2rem);

		box-shadow: inset 0 -1px 0 ${ props.theme.background};
	`}
`

export default ThickHeading
